import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import ModalCloseIcon from '../../components/FeedModal/icon-modal-close.svg';
import './ImageUpload.css';
import { Alert } from 'react-bootstrap';

class ImageUpload extends Component {
  constructor(props) {
    super(props);

    this.state = {
      disabled: false,
      preview: null
    };
    this.handleDrop = this.handleDrop.bind(this);
    this.removeImage = this.removeImage.bind(this);
    this.dropRejected = this.dropRejected.bind(this);
  }

  handleDrop(acceptedFiles) {
    const { handleImageDrop } = this.props;

    if (acceptedFiles.length > 0) {
      const { preview } = acceptedFiles[0];

      handleImageDrop(acceptedFiles[0]);

      this.setState({
        preview,
        disabled: true,
        rejectedFilesError: ''
      });
    }
  }

  dropRejected(rejectedFiles) {
    if (rejectedFiles.length > 0) {
      this.setState({
        rejectedFilesError: 'This file type is not accepted or is too large.'
      });
    }
  }

  removeImage() {
    this.setState({
      preview: null,
      disabled: false
    });
  }

  render() {
    const { preview, rejectedFilesError } = this.state;

    return (
      <div className="image-upload-container">
        {rejectedFilesError ? (
          <Alert bsStyle="danger">{rejectedFilesError}</Alert>
        ) : (
          ''
        )}
        <Dropzone
          disabledClassName="image-accepted"
          onDrop={this.handleDrop}
          accept="image/jpeg,image/jpg,image/png"
          disabled={this.state.disabled}
          multiple={false}
          onDropRejected={this.dropRejected}
        >
          <p className="image-upload-text">
            Drag a file here or click to upload.
          </p>
        </Dropzone>
        {preview && (
          <div className="image-preview">
            <img src={preview} alt="preview" />
            <img
              className="modal-close-icon"
              onClick={this.removeImage}
              src={ModalCloseIcon}
              alt="Close Icon"
            />
          </div>
        )}
      </div>
    );
  }
}

ImageUpload.propTypes = {
  handleImageDrop: PropTypes.func.isRequired
};

export default ImageUpload;



// WEBPACK FOOTER //
// ./src/components/ImageUpload/index.js